
import { Component, Vue, Prop } from 'vue-property-decorator';
import { TreeNode } from '@/modules/nomenclature/models/treeNode';

@Component({
  components: {}
})
export default class DeleteProjectForm extends Vue {
  @Prop({ required: true })
  protected value!: TreeNode;
  @Prop({ required: true })
  protected deleteCallBack!: (node: TreeNode, onDeleteCascade: boolean) => Promise<void>;
  protected sendingRequest = false;
  protected requestError = false;
  protected requestErrorChildren = false;
  protected onDeleteCascade = false;

  protected deleteProject(): void {
    this.sendingRequest = true;
    setTimeout(() => {
      this.deleteCallBack(this.value, this.onDeleteCascade)
        .then(() => {
          this.$emit('cancel');
        })
        .catch((err) => {
          if (err.response.status === 400) {
            this.requestErrorChildren = true;
            this.onDeleteCascade = true;
          } else {
            this.requestError = true;
          }
        })
        .finally(() => (this.sendingRequest = false));
    }, 500);
  }

  protected cancel(): void {
    this.requestError = false;
    this.requestErrorChildren = false;
    this.onDeleteCascade = false;
    this.$emit('cancel');
  }
}
